import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'
import { useFullScreen } from '../contexts/FullScreenContext'
import PageHeader from '../components/common/PageHeader'
import Layout from '../components/layout/Layout'
import WorkflowSteps from '../components/Returns/WorkflowSteps'

// Import existing workflow components
import Compute from '../components/Returns/Compute/Compute'
import Define from '../components/Returns/Define/Define'
import Prepare from '../components/Returns/Prepare/Prepare'
import ReturnsStep from '../components/Returns/ReturnsStep/ReturnsStep'
import ReturnUpload from '../components/Returns/Upload/ReturnUpload'
import Allocate from '../components/Returns/Allocate/Allocate'


const Returns = () => {
  const { isFullScreen } = useFullScreen()

  const [searchParams, setSearchParams] = useSearchParams()
  const [activeStep, setActiveStep] = useState('define')

  // Sync with URL parameters
  useEffect(() => {
    const step = searchParams.get('step')
    if (
      step &&
      [
        'define',
        'upload',
        'prepare',
        'compute',
        'allocate',
        'returns',
      ].includes(step)
    ) {
      setActiveStep(step)
    }
  }, [searchParams])

  const handleStepChange = stepKey => {
    setActiveStep(stepKey)
    setSearchParams({ step: stepKey })
  }

  const renderActiveComponent = () => {
    switch (activeStep) {
      case 'define':
        return <Define />
      case 'upload':
        return <ReturnUpload />
      case 'prepare':
        return <Prepare />
      case 'compute':
        return <Compute />
      case 'allocate':
        return <Allocate />
      case 'returns':
        return <ReturnsStep />
      default:
        return <Define />
    }
  }

  return (
    <Layout>
      {!isFullScreen && (
        <PageHeader title="Withholding Tax">
          <WorkflowSteps
            activeStep={activeStep}
            onStepChange={handleStepChange}
          />
        </PageHeader>
      )}

      <div>{renderActiveComponent()}</div>
    </Layout>
  )
}

export default Returns
